"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInterviewAnswerLinkProperty = exports.interviewAnswerLinkPropertyDefinition = void 0;
exports.interviewAnswerLinkPropertyDefinition = {
    view: {
        label: 'Interviewee Link',
        hint: 'Link interview answer to an Artist, Athlete, Photographer or Judge',
    },
    constraints: [
        {
            name: 'stencils',
            argument: [
                'artist',
                'athlete',
                'photographer',
                'judge',
            ],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'interview-answer-link',
};
const isInterviewAnswerLinkProperty = (prop) => {
    return prop.name === exports.interviewAnswerLinkPropertyDefinition.name;
};
exports.isInterviewAnswerLinkProperty = isInterviewAnswerLinkProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJ2aWV3LWFuc3dlci1saW5rLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvaW50ZXJ2aWV3LWFuc3dlci1saW5rLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscUNBQXFDLEdBQUc7SUFDbkQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGtCQUFrQjtRQUN6QixJQUFJLEVBQUUsb0VBQW9FO0tBQzNFO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUU7Z0JBQ1IsUUFBUTtnQkFDUixTQUFTO2dCQUNULGNBQWM7Z0JBQ2QsT0FBTzthQUNSO1NBQ0Y7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsdUJBQXVCO0NBQ0UsQ0FBQTtBQUkxQixNQUFNLDZCQUE2QixHQUFHLENBQUMsSUFBa0IsRUFBdUMsRUFBRTtJQUN2RyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssNkNBQXFDLENBQUMsSUFBSSxDQUFBO0FBQ2pFLENBQUMsQ0FBQTtBQUZZLFFBQUEsNkJBQTZCLGlDQUV6QyJ9